import { render, staticRenderFns } from "./PersonReport.vue?vue&type=template&id=c69e6772&scoped=true"
import script from "./PersonReport.vue?vue&type=script&lang=js"
export * from "./PersonReport.vue?vue&type=script&lang=js"
import style0 from "./PersonReport.vue?vue&type=style&index=0&id=c69e6772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69e6772",
  null
  
)

export default component.exports